/* eslint-disable react/sort-comp */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from "react";
import {
	DataTable,
	TableContainer,
	Table,
	TableHead,
	TableRow,
	TableBody,
	TableCell,
	TableHeader,
	TableSelectRow,
	TableToolbar,
	TableToolbarContent,
	TableBatchActions,
	TableBatchAction,
	Loading,
	TableSelectAll,
	Button,
	FormGroup,
	FormLabel,
	TextInput,
	MultiSelect,
	DropdownSkeleton,
	DataTableSkeleton,
	Pagination,
	TextInputSkeleton,
	SkeletonPlaceholder,
	TooltipDefinition,
	TooltipDefinitionProps
} from "carbon-components-react";
import moment from "moment";
import PropTypes from "prop-types";
import Add16 from "@carbon/icons-react/lib/add/16";
import Edit16 from "@carbon/icons-react/lib/edit/16";
import Error16 from "@carbon/icons-react/lib/error/16";
import Data16 from "@carbon/icons-react/lib/data--1/16";
import Send16 from "@carbon/icons-react/lib/send/16";
import Close16 from "@carbon/icons-react/lib/close/16";
import Delete16 from "@carbon/icons-react/lib/delete/16";
import Task16 from "@carbon/icons-react/lib/task/16";
import Report16 from "@carbon/icons-react/lib/report/16";
import ExportDoc16 from "@carbon/icons-react/lib/document--export/16";
import Archive16 from "@carbon/icons-react/lib/archive/16";
import Download16 from "@carbon/icons-react/lib/download/16";
import DocumentDownload16 from "@carbon/icons-react/lib/document--download/16";
import Printer from "@carbon/icons-react/lib/printer/16";

import CheckmarkOutline16 from "@carbon/icons-react/lib/checkmark--outline/16";
import SimpleReactValidator from "simple-react-validator";
import { Link } from "react-router-dom";
import { api, me, dynamic } from "../../../helpers/api/api"; //RITM0946162
import AuditTypeComboBox from "./AuditTypeComboBox";
import AuditScopeMultiSelect from "./AuditScopeMultiSelect";
import AuditTargetDropDown from "./AuditTargetDropDown";
import AuditStatusComboBox from "./AuditStatusComboBox";
import WorkSiteMultiSelect from "./WorkSiteMultiSelect";
import { WFActionModal } from "../../common/WFActionModal";
import { showNotification } from "../../../helpers/notification/BaseNotification";
import { CanExecuteAction, IsInRole } from "../../../helpers/authorization/Policies";
import { AppContext } from "../../../helpers/context/AppContext";
import { getError, STATUS, getSuccess, apioperation, entitiesLabels, sizeFormat } from "../../../helpers/Constants";
import DataApproverComboBox from "./DataApproverComboBox";
import { NoRecordsPlaceholder } from "../../../helpers/jsonschemaform/DataTableExtention";
import { StatusTag } from "../../../helpers/PageBreadCrumb";
import { Online, Offline } from "../../common/OnLineOffLine";
import FileDownLoadButton from "../../common/FileDownloadButton";
import { AuditDeleteRequest } from "./AuditDeleteRequest";
import AuditPlanStatusComboBox from "./AuditPlanStatusComboBox";
import SectionComboBox from "./SectionComboBox";
import AuditorComboBox from "./AuditorComboBox";
import OnBehalfDivisionComboBox from "./OnBehalfDivisionComboBox";
import CompanyComboBox from "./CompanyComboBox";
import OnBehalfProjectComboBox from "./OnBehalfProjectComboBox";
import ReasonForSamplingMultiSelect from "./ReasonForSamplingMultiSelect";
import CountryMultiSelect from "./CountryMultiSelect";
import ProjectAuditeeyMultiSelect from "./ProjectAuditeeMultiSelect";
import AuditRemoteComboBox from "./AuditRemoteComboBox";
import SubContractorMultiSelect from "./SubContractorMultiSelect";
import PurchaseOrderMultiSelect from "./PurchaseOrderMultiSelect";

export default class AuditMultiSelectDataTable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isApprovalModalOpen: false,
			isDeleteRequestModalOpen: false,
			approvalModalAction: "",
			approver: null,

			isLoadingApproverOptions: true,
			approvalValidationMessages: [],
			approvers: [],
			selectedData: [],
			approverRole: "",
			withApprover: true,
			isLoadingWFOperation: false,
			approvalNotesRequired: false,
			approvalNotes: null,
			// itemList: this.props.audits,
			isLoadingFile: false,
			// filteredAudits: props.allYearAudits,
			// itemsInMonths: props.itemsInMonths,
			// totalItems: props.totalItems,
			showFilters: props.showFilters,
			// filteredMonth: null,

			selectedApprover: {},
			modalDeleteVisible: false,
			modalSubmitVisible: false,
			isSubmitted: false,

			//#region RITM0646764 Estrazione Massiva Audit
			modalMassiveExtractionVisible: false,
			isLoadingModalMassiveExtraction: false,
			isLoadingTableMassiveExtraction: false,
			isLoadingDownloadMassiveExtraction: false,
			selectedCountriesMassiveExtraction: [],
			selectedBusinessLinesMassiveExtraction: [],
			countriesMassiveExtraction: [],
			businessLinesMassiveExtraction: [],
			auditsMassiveExtraction: [],
			validatorCountriesMassiveExtraction: null,
			validatorBusinessLinesMassiveExtraction: null,
			currentPageMassiveExtractionTable: 1,
			totalAuditsMassiveExtractionTable: 0,
			pageSizeMassiveExtractionTable: 5,
			reasonForAuditCancellation: [], //RITM0946162
			auditCancellationReason: null, //RITM0946162
			//#endregion
		};
		this.showFilters = this.showFilters.bind(this);
		this.onMonthFilter = this.onMonthFilter.bind(this);

		this.onSelectAuditTypeChange = this.onSelectAuditTypeChange.bind(this);
		this.onSelectStatusChange = this.onSelectStatusChange.bind(this);
		this.onSelectPlanStatusChange = this.onSelectPlanStatusChange.bind(this);
		this.onSelectAuditRemoteChange = this.onSelectAuditRemoteChange.bind(this);
		this.onSelectWorkSiteChange = this.onSelectWorkSiteChange.bind(this);
		this.onSelectTargetChange = this.onSelectTargetChange.bind(this);
		this.onSelectScopeChange = this.onSelectScopeChange.bind(this);
		this.onSelectReasonChange = this.onSelectReasonChange.bind(this);
		this.onSelectCountryChange = this.onSelectCountryChange.bind(this);
		this.onSelectProjectAuditeeChange = this.onSelectProjectAuditeeChange.bind(this);
		this.onSelectSubContractorChange = this.onSelectSubContractorChange.bind(this);
		// this.handleDeleteClose = this.handleDeleteClose.bind(this);
		// this.handleDeleteSubmit = this.handleDeleteSubmit.bind(this);
		// this.batchActionDelete = this.batchActionDelete.bind(this);
		// this.batchActionSubmit = this.batchActionSubmit.bind(this);
		// this.handleStatusSubmitClose = this.handleStatusSubmitClose.bind(this);
		// this.handleStatusSubmit = this.handleStatusSubmit.bind(this);
		this.onSelectDataApproverChange = this.onSelectDataApproverChange.bind(this);
		this.renderLoadingModal = this.renderLoadingModal.bind(this);
		// this.isRequestCancellationPending = this.isRequestCancellationPending.bind(this);
		this.validator = new SimpleReactValidator();

		this.validations = {
			dataApprover: this.validator.message("dataApprover", this.state.selectedApprover.id, "required"),
		};
	}

	DownloadAuditNotification(auditId) {
		this.setState({ isLoadingFile: true });
		api.getWithParam(`/audit/${auditId}/export`, { responseType: "arraybuffer" })
			.then((response) => {
				const data = new Blob([response.data], { type: "application/pdf" });
				const csvURL = window.URL.createObjectURL(data);
				const tempLink = document.createElement("a");
				tempLink.href = csvURL;
				const auditCode = this.props.audits.find((i) => i.id === auditId);
				const nomefile = `Audit_Notification_${auditCode.auditCode}.zip`;
				tempLink.setAttribute("download", nomefile);
				document.body.appendChild(tempLink);
				tempLink.click();
			})
			.catch((error) => {
				showNotification.error(getError(error, entitiesLabels.INCIDENT_NOTIFICATION, apioperation.DOWNLOAD));
			})
			.finally(() => {
				this.setState({ isLoadingFile: false });
			});
	}

	DownloadAuditReport(auditId) {
		this.setState({ isLoadingFile: true });
		api.getWithParam(`/audit/${auditId}/exportreport`, { responseType: "arraybuffer" })
			.then((response) => {
				const data = new Blob([response.data], { type: "application/pdf" });
				const csvURL = window.URL.createObjectURL(data);
				const tempLink = document.createElement("a");
				tempLink.href = csvURL;
				const auditCode = this.props.audits.find((i) => i.id === auditId);
				const nomefile = `Audit_Report_${auditCode.auditCode}.zip`;
				tempLink.setAttribute("download", nomefile);
				document.body.appendChild(tempLink);
				tempLink.click();
			})
			.catch((error) => {
				showNotification.error(getError(error, entitiesLabels.INCIDENT_NOTIFICATION, apioperation.DOWNLOAD));
			})
			.finally(() => {
				this.setState({ isLoadingFile: false });
			});
	}

	// static getDerivedStateFromProps() {
	//   // Any time the current user changes,
	//   // Reset any parts of state that are tied to that user.
	//   // In this simple example, that's just the email.
	//   // if (props.allYearAudits !== state.filteredAudits) {
	//   //   return {
	//   //     filteredAudits: props.allYearAudits,
	//   //   };
	//   // }
	//   // if (props.itemsInMonths !== state.itemsInMonths) {
	//   //   return {
	//   //     itemsInMonths: props.itemsInMonths,
	//   //   };
	//   // }

	//   return null;
	// }

	renderFilters = () =>
		// <div style={{ display: this.state.showFilters ? 'block' : 'none' }}>
		this.state.showFilters && (
			<>
				<div className="bx--row">
					<FormGroup className="bx--col-lg-3 bx--col-md-3">
						{/*RITM0544059*/}
						<FormLabel>Section</FormLabel>
						<SectionComboBox	onChange={this.props.onChangeSectionFilter} 
							onError={(error) => {	showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.SECTION, apioperation.GET))}}
							selectedItem={this.props.selectedSection}
							disabled={false}
						/>
					</FormGroup>
					<FormGroup className="bx--col-lg-3 bx--col-md-3" legendText="">
						<FormLabel>Audit Criteria</FormLabel>
						<AuditScopeMultiSelect onChange={this.onSelectScopeChange} onError={() => {}} initialSelectedItems={this.props.selectedScopes} loadAll disabled={false} />
					</FormGroup>
					<FormGroup className="bx--col-lg-3 bx--col-md-3" legendText="">
						<FormLabel>Target</FormLabel>
						<AuditTargetDropDown onChange={this.onSelectTargetChange} onError={() => {}} initialSelectedItem={this.props.selectedTarget} loadAll disabled={false} />
					</FormGroup>
					<FormGroup className="bx--col-lg-3 bx--col-md-3" legendText="">
						<FormLabel>Type</FormLabel>
						<AuditTypeComboBox onChange={this.onSelectAuditTypeChange} onError={() => {}} initialSelectedItem={this.props.selectedAuditType} loadAll disabled={false} />
					</FormGroup>
				</div>


					
				
				<div className="bx--row">
					<FormGroup className="bx--col-lg-3 bx--col-md-3" legendText="">
						<FormLabel>Program Status</FormLabel>
						<AuditPlanStatusComboBox onChange={this.onSelectPlanStatusChange} onError={() => {}} initialSelectedItem={this.props.selectedPlanStatus} loadAll disabled={false} />
					</FormGroup>

					<FormGroup className="bx--col-lg-3 bx--col-md-3" legendText="">
						<FormLabel>Report Status</FormLabel>
						<AuditStatusComboBox onChange={this.onSelectStatusChange} onError={() => {}} initialSelectedItem={this.props.selectedStatus} loadAll disabled={false} />
					</FormGroup>

					<FormGroup className="bx--col-lg-3 bx--col-md-3" legendText="">
						<FormLabel>Worksite</FormLabel>
						<WorkSiteMultiSelect onChange={this.onSelectWorkSiteChange} onError={() => {}} loadAll initialSelectedItems={this.props.selectedWorkSites} disabled={false} />
					</FormGroup>

					<FormGroup className="bx--col-lg-3 bx--col-md-3" legendText="">
						<FormLabel>Reason for Sampling</FormLabel>
						<ReasonForSamplingMultiSelect onChange={this.onSelectReasonChange} onError={() => {}} initialSelectedItems={this.props.selectedReasons} filter disabled={false} />
					</FormGroup>

				</div>

				<div className="bx--row">
					<FormGroup className="bx--col-lg-3 bx--col-md-3">
						{/*RITM0544059*/}
						<FormLabel>Lead Auditor</FormLabel>
						<AuditorComboBox
							onChange={this.props.onChangeLeadAuditorFilter}
							onError={(error) => {
								showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.AUDITOR, apioperation.GET));
							}}
							//userDivision={this.props.userDivision || []} //B1_Audit_Module_Optimization
							selectedItem={this.props.selectedLeadAuditor}
							disabled={false}
						/>
					</FormGroup>
					<FormGroup className="bx--col-lg-3 bx--col-md-3">
						{/*RITM0544059*/}
						{/* RITM0945977 */}
						{/* <FormLabel>Division of Lead Auditor</FormLabel> */}
						<FormLabel>Business Line of Lead Auditor</FormLabel>
						<OnBehalfDivisionComboBox
							onChange={this.props.onChangeDivisionLeadAuditorFilter}
							onError={(error) => {
								showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.MAINDIVISION, apioperation.GET));
							}}
							selectedItem={this.props.selectedDivisionLeadAuditor || ""}
							getMyDivision={true}
							disabled={false}
						/>
					</FormGroup>
					<FormGroup className="bx--col-lg-3 bx--col-md-3">
						{/*RITM0544059*/}
						<FormLabel>Company of Lead Auditor</FormLabel>
						<CompanyComboBox
							onChange={this.props.onChangeCompanyLeadAuditorFilter}
							onError={(error) => {
								showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.COMPANY, apioperation.GET));
							}}
							selectedItem={this.props.selectedCompanyLeadAuditor}
							disabled={false}
						/>
					</FormGroup>
					<FormGroup className="bx--col-lg-3 bx--col-md-3">
						{/*RITM0544059*/}
						<FormLabel>Project of Lead Auditor</FormLabel>
						<OnBehalfProjectComboBox
							onChange={this.props.onChangeProjectLeadAuditorFilter}
							company={"ALL"}
							onError={(error) => {
								showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.PROJECT, apioperation.GET));
							}}
							selectedItem={this.props.selectedProjectLeadAuditor}
							disabled={false}
						/>
					</FormGroup>
				</div>


				<div className="bx--row">

					<FormGroup className="bx--col-lg-3 bx--col-md-3">
						<FormLabel>Email Team Leader</FormLabel>
						<TextInput
							id="inputFilterCompiler"
							labelText=""
							onChange={(event) => this.props.onCompilerFilter(event.target.value)}
							placeholder="Input Compiler"
							type="text"
							value={this.props.selectedCompiler || ""}
						/>
					</FormGroup>
					<FormGroup className="bx--col-lg-3 bx--col-md-3">
						<FormLabel>Email Program Compiler</FormLabel>
						<TextInput
							id="inputFilterPlanCompiler"
							labelText=""
							onChange={(event) => this.props.onPlanCompilerFilter(event.target.value)}
							placeholder="Input Plan Compiler"
							type="text"
							value={this.props.selectedPlanCompiler || ""}
						/>
					</FormGroup>
					<FormGroup className="bx--col-lg-3 bx--col-md-3">
						<FormLabel>Email Data Approver</FormLabel>
						<TextInput
							id="inputFilterApprover"
							labelText=""
							onChange={(event) => this.props.onApproverFilter(event.target.value)}
							placeholder="Input Data Approver"
							type="text"
							value={this.props.selectedApprover || ""}
						/>
					</FormGroup>

					<FormGroup className="bx--col-lg-3 bx--col-md-3">
						<FormLabel>Audit in Remote Mode</FormLabel>
						<AuditRemoteComboBox onChange={this.onSelectAuditRemoteChange} onError={() => {}} initialSelectedItem={this.props.selectedAuditRemote} disabled={false} />
					</FormGroup>

					{/* <FormGroup className="bx--col-lg-3 bx--col-md-4">
					<FormLabel>Email Consolidator</FormLabel>
					<TextInput
					id="inputFilterManager"
					labelText=""
					onChange={(event) => this.props.onDivisionManagerFilter(event.target.value)}
					placeholder="Input Consolidator "
					type="text"
					value={this.props.selectedDivisionManager || ''}
					/>
					</FormGroup> */}
				</div>

				<div className="bx--row">

					<FormGroup className="bx--col-lg-3 bx--col-md-3">
						<FormLabel>Project of Auditee</FormLabel>
						<ProjectAuditeeyMultiSelect 
							onChange={this.onSelectProjectAuditeeChange} 
							onError={() => {}} 
							initialSelectedItems={this.props.selectedProjectsAuditee} 
							disabled={false} />
					</FormGroup>
					<FormGroup className="bx--col-lg-3 bx--col-md-3" legendText="">
						<FormLabel>Country of Auditee</FormLabel>
						<CountryMultiSelect 
							onChange={this.onSelectCountryChange} 
							onError={() => {}} 
							initialSelectedItems={this.props.selectedCountries} 
							disabled={false} />
					</FormGroup>

					<FormGroup className="bx--col-lg-3 bx--col-md-3" legendText="">
						<FormLabel>SubContractor/Supplier</FormLabel>
						<TextInput 
							id="auditSubContractorSelect" 
							labelText="" 
							onChange={(event) => this.onSelectSubContractorChange(event.target.value)} 
							placeholder="Insert subcontractor" 
							type="text" 
							value={this.props.selectedSubContractors || ""} />
					</FormGroup>

					<FormGroup className="bx--col-lg-3 bx--col-md-3">
						<FormLabel>Purchase Order</FormLabel>
						<TextInput 
							id="auditPurchaseOrderSelect" 
							labelText="" 
							onChange={(event) => this.onSelectPurchaseOrderChange(event.target.value)} 
							placeholder="Insert purchase order" 
							type="text" 
							value={this.props.selectedPurchaseOrder || ""} />
					</FormGroup>
				</div>

				{/* RITM0646764 : Aggiuna filtri */}
				<div className="bx--row">
					<FormGroup className="bx--col-lg-3 bx--col-md-3">
						<FormLabel>Audit Code</FormLabel>
						<TextInput 
							id="inputFilterCode" 
							labelText="" 
							onChange={(event) => this.props.onCodeFilter(event.target.value)} 
							placeholder="Input Audit Code" 
							type="text" 
							value={this.props.selectedCode || ""} />
					</FormGroup>
					<FormGroup className="bx--col-lg-3 bx--col-md-3">
						<FormLabel>Project Audit Code (manual input)</FormLabel>
						<TextInput 
							id="inputFilterProjectAuditCode" 
							labelText="" 
							onChange={(event) => this.props.onProjectAuditCodeFilter(event.target.value)} 
							placeholder="Input Project Audit Code " 
							type="text" 
							value={this.props.selectedProjectAuditCode || ""} 
						/>
					</FormGroup>
					<FormGroup className="bx--col-lg-3 bx--col-md-3">
						<FormLabel>Finding Code</FormLabel>
						<TextInput 
							id="inputFilterFindingCode" 
							labelText="" 
							onChange={(event) => this.props.onFindingCodeFilter(event.target.value)} 
							placeholder="Input Finding Code" 
							type="text" 
							value={this.props.selectedFindingCode || ""} />
					</FormGroup>
					<FormGroup className="bx--col-lg-3 bx--col-md-3">
						<FormLabel>Project Finding Code (manual input)</FormLabel>
						<TextInput 
							id="inputFilterProjectFindingCode" 
							labelText="" 
							onChange={(event) => this.props.onProjectFindingCodeFilter(event.target.value)} 
							placeholder="Input Project Finding Code " 
							type="text" 
							value={this.props.selectedProjectFindingCode || ""} 
						/>
					</FormGroup>
				</div>
				{/* RITM0646764 : FINE */}
				<div className="searchFormFooter">
					<Button className="button--max-width" size="small" kind="secondary" onClick={this.props.onSearchClear}>
						Cancel
					</Button>
					<Button className="button--max-width" size="small" onClick={this.props.onSearch}>
						Search
					</Button>
				</div>
			</>
		);

	renderLoadingModal = () => {
		const show = this.state.isSubmitted;
		return show && <Loading active withOverlay description="Saving..." />;
	};

	renderDeleteModal = (totalItems) =>
		this.state.modalDeleteVisible && (
			<div className="bx--modal bx--modal-tall is-visible">
				<div className="bx--modal-container">
					<div className="bx--modal-header">
						<h3 className="bx--modal-header__heading"> Delete draft audits</h3>
						<Button className="bx--modal-close" renderIcon={Close16} onClick={this.handleDeleteClose} />
					</div>

					<div className="bx--modal-content">
						<div className="bx--row" />
						<div className="bx--col-lg-12 bx--col-md-12">
							<h4 className="align-center">
								Press confirm to delete
								{` ${totalItems} `}
								audit/s selected
							</h4>
						</div>
					</div>
					<div className="bx--modal-footer">
						<Button className="button--max-width" kind="secondary" onClick={this.handleDeleteClose}>
							Cancel
						</Button>
						<Button className="button--max-width" kind="primary" onClick={this.handleDeleteSubmit}>
							Confirm
						</Button>
					</div>
				</div>
			</div>
		);

	renderSubmitModal = (totalItems) => {
		const validations = {
			dataApprover: this.validator.message("dataApprover", this.state.selectedApprover.id, "required"),
		};
		return (
			this.state.modalSubmitVisible && (
				<div className="bx--modal bx--modal-tall is-visible">
					<div className="bx--modal-container">
						<div className="bx--modal-header">
							<h3 className="bx--modal-header__heading">Submit audits</h3>
							<Button className="bx--modal-close" renderIcon={Close16} onClick={this.handleStatusSubmitClose} />
						</div>

						<div className="bx--modal-content bx-modal-content-detail">
							<div className="bx--row" />
							<div className="bx--col-lg-12 bx--col-md-12">
								<h5 className="align-center">
									Choose a Data Approver and than confirm to submit
									{` ${totalItems} `}
									audit/s selected
								</h5>
							</div>
							<div className="bx--row" />
							<div className="bx--col-lg-12 bx--col-md-12">
								<FormGroup>
									<FormLabel className="some-class">Data Approver</FormLabel>
									<DataApproverComboBox
										onChange={this.onSelectDataApproverChange}
										onError={(error) => {
											showNotification.error(getError(error, "loading data approver", "ERROR"));
										}}
									/>
									{validations.dataApprover}
								</FormGroup>
							</div>
						</div>
						<div className="bx--modal-footer">
							<Button className="button--max-width" kind="secondary" onClick={this.handleStatusSubmitClose}>
								Cancel
							</Button>
							<Button className="button--max-width" kind="primary" onClick={this.handleStatusSubmit}>
								Confirm
							</Button>
						</div>
					</div>
				</div>
			)
		);
	};

	onSelectAuditTypeChange = (selectedItem) => {
		this.props.onTypeFilter(selectedItem);
	};

	onSelectReasonChange = (selectedItem) => {
		this.props.onReasonFilter(selectedItem);
	};

	onSelectCountryChange = (selectedItem) => {
		this.props.onCountryFilter(selectedItem);
	};

	onSelectProjectAuditeeChange = (selectedItem) => {
		this.props.onProjectAuditeeFilter(selectedItem);
	};

	onSelectSubContractorChange = (selectedItem) => {
		this.props.onSubContractorFilter(selectedItem);
	};

	onSelectPurchaseOrderChange = (selectedItem) => { //RITM0646764
		this.props.onPurchaseOrderFilter(selectedItem);
	};

	onSelectScopeChange = (selectedItem) => {
		this.props.onScopeFilter(selectedItem);
	};

	onSelectTargetChange = (selectedItem) => {
		this.props.onTargetFilter(selectedItem);
	};

	onSelectStatusChange = (selectedItem) => {
		this.props.onStatusFilter(selectedItem);
	};

	onSelectPlanStatusChange = (selectedItem) => {
		this.props.onPlanStatusFilter(selectedItem);
	};

	onSelectAuditRemoteChange = (selectedItem) => {
		this.props.onAuditRemoteFilter(selectedItem);
	};

	onSelectWorkSiteChange = (selectedItem) => {
		this.props.onWorkSiteFilter(selectedItem);
	};

	onSelectDataApproverChange = (selectedItem) => {
		this.setState({
			selectedApprover: selectedItem || {},
		});
	};

	// buildNoMonthFilter = () => {
	//   let { filteredAudits } = this.state;
	//   filteredAudits = this.state.filteredDivision
	//     ? filteredAudits.filter((item) => item.idDivision === this.state.filteredDivision)
	//     : filteredAudits;
	//   return filteredAudits;
	// };

	onMonthFilter = (event) => {
		// this.setState({
		//   filteredMonth: event.currentTarget.id > 0 ? parseInt(event.currentTarget.id, 10) : null,
		//   //   filteredAudits: this.buildNoMonthFilter(),
		// });
		this.props.onMonthFilter(event.currentTarget.id > 0 ? parseInt(event.currentTarget.id, 10) : null);
	};

	handleApproverSelect = (selectedItem) => {
		this.setState({ approver: selectedItem });
	};

	//RITM0946162
	handleReasonForAuditCancellationSelect = (selectedItem) => {
		this.setState({ auditCancellationReason: selectedItem });
	};
	//End

	handleCloseApprovalModal = () => {
		this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
	};

	handleCloseDeleteRequestModal = () => {
		this.setState({ isDeleteRequestModalOpen: false }, this.clearDeleteRequestForm);
	};

	handleApprovalNotesChange = (e) => {
		this.setState({ approvalNotes: e.target.value });
	};

	clearDeleteRequestForm = () => {
		this.setState({ approvalNotes: null, approver: null });
	};

	handleConfirmDeleteRequestModal = () => {
		const data = {
			ids: this.state.selectedData.map((r) => r.id),
			owner: this.state.approver,
			workflowNotes: this.state.approvalNotes,
			auditCancellationReason: this.state.auditCancellationReason, //RITM0946162
		};

		this.setState({
			isLoadingWFOperation: true,
		});
		api.put("/audit/deleterequest", data, "")
			.then((response) => {
				if (response.status === 200) {
					showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.AUDIT, apioperation.PUT));
					this.setState({
						isLoadingWFOperation: false,
						isDeleteRequestModalOpen: false,
						// isLoading: true,
						// itemList: []
					});
					this.props.onRefreshData();
				} else {
					showNotification.error();
					this.setState({
						isLoadingWFOperation: false,
					});
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, error.response.data, "ERROR"));
				this.setState({
					isLoadingWFOperation: false,
				});
			})
			.finally(() => {});
	};

	handleConfirmApprovalModal = () => {
		const apiEndpoint = this.state.approvalEndpoint;
		const data = {
			ids: this.state.selectedData.map((r) => r.id),
			owner: this.state.approver,
			workflowNotes: this.state.approvalNotes,
		};

		this.setState({
			isLoadingWFOperation: true,
		});
		api.put(`/audit/${apiEndpoint}`, data, "")
			.then((response) => {
				if (response.status === 200) {
					showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.AUDIT, apioperation.PUT));
					this.setState({
						isLoadingWFOperation: false,
						isApprovalModalOpen: false,
						// isLoading: true,
						// itemList: []
					});
					this.props.onRefreshData();
				} else {
					showNotification.error();
					this.setState({
						isLoadingWFOperation: false,
					});
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, error.response.data, "ERROR"));
				this.setState({
					isLoadingWFOperation: false,
				});
			})
			.finally(() => {});
	};

	getUsersInRole = (role, idEntity) => {
		me.getWithParam("users", {
			params: { Role: role, IdEntity: idEntity, includeAdmins: true },
		})
			.then((response) => {
				this.setState({
					approvers: response.data,
					isLoadingApproverOptions: false,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, "", "ERROR"));
			})
			.finally(() => {
				this.setState({
					isLoadingApproverOptions: false,
				});
			});
	};

	//RITM0946162
	getReasonForAuditCancellation = async () => {
		await dynamic.getAll("reasonforauditcancellation", {
			params: { page: 0, parent: 'all' },
		})
			.then((response) => {
				this.setState({
					reasonForAuditCancellation: response.data.itemList.filter((c) => c.inUse),
					isLoadingApproverOptions: false,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, "", "ERROR"));
				console.log(error);
			})
			.finally(() => {
				this.setState({
					isLoadingApproverOptions: false,
				});
			});
	};

	// eslint-disable-next-line react/sort-comp
	IsRowSelectable(tableRow, selectedRows) {
		const row = this.props.audits.find((i) => i.id === tableRow.id);
		if (!row || !row.status) return false;
		// if (row.checkList?.notificationForm?.sendedOn == null && row.checkList != null) return false;

		// if (row.checkList != null && !row.allQstAnswered) return false;

		if (row.status.id === STATUS.Consolidated) {
			if (row.checkList && row.checkList.idStatus === STATUS.Consolidated) return false;
		}

		if (selectedRows.length === 0) {
			return true;
		}

		if (selectedRows.length > 0) {
			const selectableAudit = this.props.audits.find((i) => i.id === selectedRows[0].id);
			const selectableState = selectableAudit.idStatus;
			const selectableDivision = selectableAudit.idDivision;
			const selectableWorksite = selectableAudit.idWorksite;

			const rowStateRep = row.checkList ? row.checkList.idStatus : null;
			const selectableStateRep = selectableAudit.checkList ? selectableAudit.checkList.idStatus : null;

			if (
				selectableState === 4 &&
				selectableState === row.idStatus &&
				rowStateRep === selectableStateRep &&
				row.idDivision === selectableDivision &&
				((row.deleteRequest != null && selectableAudit.deleteRequest != null) || (row.deleteRequest == null && selectableAudit.deleteRequest == null))
			) {
				return true;
			}
			if (row.idStatus === selectableState && rowStateRep === selectableStateRep && (row.idStatus === STATUS.Draft ? row.idWorksite === selectableWorksite : row.idDivision === selectableDivision)) {
				return true;
			}

			return false;
		}

		return false;
	}

	batchActionClick(actionKey, actionName, approverRole, withApprover, approvalNotesRequired, selectedRows) {
		const audit = this.props.audits.find((i) => i.id === selectedRows[0].id);

		const idEntity = audit.idDivision;

		//    actionKey == 'Submit' || actionKey == 'submitreport'
		//        ? audit.idWorksite
		//        : actionKey == 'Approve' || actionKey == 'approvereport'
		//            ? audit.idDivision
		//            : null;

		this.setState({
			approvalModalAction: actionName,
			isApprovalModalOpen: true,
			isLoadingApproverOptions: true,
			withApprover,
			selectedData: selectedRows,
			approverRole,
			approvalEndpoint: actionKey,
			approvalNotesRequired,
			statewf: audit.status.id,
		});

		if (withApprover) this.getUsersInRole(approverRole, idEntity);
	}

	deleteActionClick(selectedRows) {
		const audit = this.props.audits.find((i) => i.id === selectedRows[0].id);

		const idEntity = audit.idDivision;

		//    actionKey == 'Submit' || actionKey == 'submitreport'
		//        ? audit.idWorksite
		//        : actionKey == 'Approve' || actionKey == 'approvereport'
		//            ? audit.idDivision
		//            : null;

		this.setState({
			isDeleteRequestModalOpen: true,
			isLoadingApproverOptions: true,
			selectedData: selectedRows,
			statewf: audit.status.id,
		});

		this.getReasonForAuditCancellation();
		this.getUsersInRole("Administrator", idEntity);
		console.log(this.state.reasonForAuditCancellation);
		//this.getReasonForAuditCancellation() //RITM0946162
	}
	/** ***********Render******************* */

	getAuditCode = (id) => {
		const auditCode = this.props.audits.find((el) => el.id === id);
		return `Audit_Notification_${auditCode.auditCode}.zip`;
	};

	getAuditReportCode = (id) => {
		const auditCode = this.props.audits.find((el) => el.id === id);
		return `Audit_Report_${auditCode.auditCode}.zip`;
	};

	getAudit = (selectedRows) => {
		if (selectedRows && selectedRows.length > 0) {
			return this.props.audits.find((el) => el.id === selectedRows[0].id);
		}
		return null;
	};

	getAuditor = (selectedRows) => {
		if (selectedRows && selectedRows.length > 0) {
			const au = this.props.audits.find((el) => el.id === selectedRows[0].id);
			return au && au.auditors && au.auditors[0] ? { idCompiler: au.auditors[0].id } : null;
		}
		return null;
	};

	getAuditReport = (selectedRows) => {
		if (selectedRows && selectedRows.length > 0) {
			const r = this.props.audits.find((el) => el.id === selectedRows[0].id);
			return r && r.checkList;
		}
		return null;
	};

	getStatusId = (idRow) => {
		const r = this.props.audits.find((el) => el.id === idRow);
		return r && r.idStatus;
	};

	getReportStatusId = (idRow) => {
		const r = this.props.audits.find((el) => el.id === idRow);
		return r && r.checkList && r.checkList.idStatus;
	};

	getNewCarManagement = (idRow) => {
		const r = this.props.audits.find((el) => el.id === idRow);
		return r && r.newCarManagement;
	};

	isRequestCancellationPending = (idRow) => {
		const r = this.props.audits.find((el) => el.id === idRow);
		return r && r.deleteRequest != null;
	};

	canSubmit = (idRow) => {
		const r = this.props.audits.find((el) => el.id === idRow);
		if (r.checkList?.notificationForm?.sendedOn == null && r.checkList != null) return false;
		if (r.checkList != null && !r.allQstAnswered) return false;
	};

	isAllRequestCancellationPending = (rows) => {
		let result = true;
		for (let i = 0; i < rows.length; i += 1) {
			const r = this.props.audits.find((el) => el.id === rows[i].id);
			result = r && r.deleteRequest == null;
			if (!result) break;
		}
		return result;
	};

	isMyRequestCancellationPending = (idRow, user) => {
		const r = this.props.audits.find((el) => el.id === idRow);
		return r && r.deleteRequest != null && r.deleteRequest.idUserRequestTo === user.id;
	};

	isAllMyRequestCancellationPending = (rows, user) => {
		for (let i = 0; i < rows.length; i += 1) {
			const r = this.props.audits.find((el) => el.id === rows[i].id);
			if (!(r && r.deleteRequest != null && r.deleteRequest.idUserRequestTo === user.id)) return false;
		}
		return true;
	};

	renderMonthsHeader = () => {
		const elements = ["All", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
		const items = elements.map((item, index) => (
			// eslint-disable-next-line jsx-a11y/interactive-supports-focus
			<div
				focusable="true"
				onClick={this.onMonthFilter}
				className={` bx--col bx--header-orientation header-calendar row-description-calendar  ${
					(!this.props.selectedMonth && index === 0) || this.props.selectedMonth === index ? "bx--header-orientation-current" : ""
				}`}
				id={index}
				key={`monthHead-${item}`}
				role="button"
			>
				<div className="detail">{item}</div>

				<div className="information-number number tableNumber">{index > 0 ? this.props.itemsInMonths.find((elem) => elem.key === index)?.count || 0 : this.props.itemsInMonths.reduce((a, b) => a + b.count, 0)}</div>
			</div>
		));

		return <div className="bx--row description-header ">{items}</div>;
	};

	getCellValue = (type, value, isLoading = false) => {
		if(isLoading){
			return <SkeletonPlaceholder style={{height: '16px'}}/>
		}

		if (!value) return "";
		if (typeof value === "object") {
			if (type.header.includes("auditor")) {
				return value.fullName;
			}
			if (type.header.includes("status")) {
				return <StatusTag value={value.planningName} />;
			}
			if (type.header.includes("checkList")) {
				return <StatusTag value={value.status.reportingName} />;
			}

			if (value instanceof Array) {
				return value.map((elem) => elem.name).join(", ");
			}
			return value.name;
		}
		if (type.header.includes("Month")) {
			const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
			const monthToString = (monthNumber) => months[monthNumber - 1] || "";
			return monthToString(value);
		}
		if(type.header === "size"){
			return sizeFormat(value)
		}
		
		return value;
	};

	showFilters() {
		this.setState((oldState) => ({ showFilters: !oldState.showFilters }));
		this.props.onShowFilters();
	}

	//#region RITM0646764 Estrazione Massiva Audit
	openMassiveExtractionModal = () => {
		this.setState({
			modalMassiveExtractionVisible: true,
		}, () => {
			this.getCountriesBusinessLines();
		})
	}

	closeMassiveExtractionModal = () => {
		this.setState({
			modalMassiveExtractionVisible: false,
			isLoadingModalMassiveExtraction: false,
			isLoadingTableMassiveExtraction: false,
			isLoadingDownloadMassiveExtraction: false,
			selectedCountriesMassiveExtraction: [],
			selectedBusinessLinesMassiveExtraction: [],
			countriesMassiveExtraction: [],
			businessLinesMassiveExtraction: [],
			auditsMassiveExtraction: [],
			validatorCountriesMassiveExtraction: null,
			validatorBusinessLinesMassiveExtraction: null,
			currentPageMassiveExtractionTable: 1,
			totalAuditsMassiveExtractionTable: 0,
			pageSizeMassiveExtractionTable: 5
		})
	}

	getCountriesBusinessLines = () => {
		this.setState({ isLoadingModalMassiveExtraction: true });
		api.getAll(`/audit/getcountriesbusinesslines`)
			.then((response) => {
				const data = response.data;
				this.setState({
					countriesMassiveExtraction: data.countries || [],
					businessLinesMassiveExtraction: data.businessLines || []
				})
			})
			.catch((error) => {
				showNotification.error(getError(error, entitiesLabels.AUDITMASSIVEEXTRACTION_GETCOUNTRIESBUSINESSLINES, apioperation.GET));
			})
			.finally(() => {
				this.setState({ isLoadingModalMassiveExtraction: false });
			});
	}

	searchAuditsForMassiveExtractionModal = () => {
		if(this.checkValidatorMassiveExtraction()){
			this.setState({ 
				isLoadingDownloadMassiveExtraction: true,
				isLoadingTableMassiveExtraction: true
			});
			const skip = (this.state.currentPageMassiveExtractionTable - 1) * this.state.pageSizeMassiveExtractionTable;
			api.post(`/audit/getauditdocuments/skip/${skip}/take/${this.state.pageSizeMassiveExtractionTable}`, 
				{countries: (this.state.selectedCountriesMassiveExtraction || []), businessLines: (this.state.selectedBusinessLinesMassiveExtraction || [])})
				.then((response) => {
					const data = response.data;
					this.setState({
						auditsMassiveExtraction: data.audits,
						totalAuditsMassiveExtractionTable: data.totCount,
						currentPageMassiveExtractionTable: 1,
					})
				})
				.catch((error) => {
					showNotification.error(getError(error, entitiesLabels.AUDITMASSIVEEXTRACTION_GETAUDITS, apioperation.GET));
				})
				.finally(() => {
					this.setState({ 
						isLoadingDownloadMassiveExtraction: false,
						isLoadingTableMassiveExtraction: false
					});
				});
		}		
	}

	hanldeChangeMassiveExtraction = (type, items) => {
		if(type === 'countries'){
			this.setState({
				selectedCountriesMassiveExtraction: items?.selectedItems || [],
				validatorCountriesMassiveExtraction: null,
				validatorBusinessLinesMassiveExtraction: null
			})
		}

		if(type === 'businessLines'){
			this.setState({
				selectedBusinessLinesMassiveExtraction: items?.selectedItems || [],
				validatorCountriesMassiveExtraction: null,
				validatorBusinessLinesMassiveExtraction: null
			})
		}
	}

	checkValidatorMassiveExtraction = () => {
		var selectedCountries = this.state.selectedCountriesMassiveExtraction || [];
		var selectedBusinessLine = this.state.selectedBusinessLinesMassiveExtraction || [];
		if(selectedCountries.length === 0 && selectedBusinessLine.length === 0){
			this.setState({
				validatorCountriesMassiveExtraction: 'Choose at least one country and/or business line',
				validatorBusinessLinesMassiveExtraction: 'Choose at least one country and/or business line'
			});
			return false;
		}
		
		this.setState({
			validatorCountriesMassiveExtraction: null,
			validatorBusinessLinesMassiveExtraction: null
		});

		return true;
	}

	handleChangePagingMassiveExtractionTable = (page) => {
		this.setState({
			currentPageMassiveExtractionTable: page.page,
			pageSizeMassiveExtractionTable: page.pageSize
		}, () => {
			this.searchAuditsForMassiveExtractionModal();
		})
	};

	downloadMassiveExtraction = (selectedRows) => {
		if(!this.ifMaximumLimit(selectedRows)){				
			this.setState({ 
				isLoadingDownloadMassiveExtraction: true,
				isLoadingTableMassiveExtraction: true
			});

			let input = {
				ids: selectedRows?.map(x => x['id']),
				isSingle: false
			};

			api.postBlob(`/audit/downloadzipmassiveextraction`, input)
				.then((response) => {
					const link = document.createElement('a');
					// Browsers that support HTML5 download attribute
					if (link.download !== undefined) {
						var currentdate = new Date(); 
						var datetime =  (currentdate.getMonth()+1).toString() +
										currentdate.getDate().toString() +
										currentdate.getFullYear().toString() +
										currentdate.getHours().toString() +  
										currentdate.getMinutes().toString() + 
										currentdate.getSeconds().toString();
						var fileName = 'Audits_' + datetime + '.zip';
	
						const url = URL.createObjectURL(response.data);
						link.setAttribute('href', url);
						link.setAttribute('download', fileName);
						link.style.visibility = 'hidden';
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					}
				})
				.catch((error) => {
					showNotification.error(getError(error, entitiesLabels.AUDITMASSIVEEXTRACTION_GETAUDITS, apioperation.GET));
				})
				.finally(() => {
					this.setState({ 
						isLoadingDownloadMassiveExtraction: false,
						isLoadingTableMassiveExtraction: false
					});
				});
		}
		else{
			showNotification.error('Download maximum of 5 audits at a time');
		}		
	}

	// calculateTotalByte = (selectedRows) => {
	// 	var total = 0;

	// 	if(selectedRows !== null){
	// 		var sizes = selectedRows?.map(x => x?.cells[3]?.value);			
			
	// 		if(sizes !== null && sizes !== [] && sizes !== undefined){
	// 			sizes.forEach(size => {
	// 				total += parseInt(size);
	// 			});
	// 		}
	// 	}

	// 	return sizeFormat(total);
	// }
	
	ifMaximumLimit = (selectedRows) => {
		if(selectedRows?.length <= 5) return false;
		
		return true
	}

	isRowSelectablemassiveExtractionTable(tableRow) {
		if(tableRow !== null && tableRow !== undefined){
			if(tableRow.cells[3].value !== 0 
			&& tableRow.cells[3].value !== '' 
			&& tableRow.cells[3].value !== '0'
			&& tableRow.cells[3].value !== undefined
			&& tableRow.cells[3].value !== null){
				return true;
			}
		}

		return false;
	}

	renderMassiveExtractionModal = () => {
		const headersMassiveExtractionTable = [
			{
				key: "auditCode",
				header: "Audit Code",
				isSortable: true,
			},
			{
				key: "country",
				header: "Country",
				isSortable: true,
			},
			{
				key: "businessLine",
				header: "Business Line",
			}		
		]

		const loadingRows = [
			{
				id: 0,
				auditCode: '',
				country: '',
				businessLine: ''
			},
			{
				id: 1,
				auditCode: '',
				country: '',
				businessLine: ''
			},
			{
				id: 2,
				auditCode: '',
				country: '',
				businessLine: ''
			},
			{
				id: 3,
				auditCode: '',
				country: '',
				businessLine: ''
			},
			{
				id: 4,
				auditCode: '',
				country: '',
				businessLine: ''
			},
		]

		const paginationMassiveExtractionTableProps = () => ({
			page: this.state.MassiveExtractionTable || 1,
			totalItems: this.state.totalAuditsMassiveExtractionTable || 0,
			pageSize: this.state.pageSizeMassiveExtractionTable || 5,
			pageSizes: [5, 10, 20, 30, 40, 50],
			onChange: this.handleChangePagingMassiveExtractionTable,
		});

		return (
			this.state.modalMassiveExtractionVisible && (
				<div className="bx--modal bx--modal-tall is-visible">
					<div className="bx--modal-container" style={{height: '90%'}}>
						<div className="bx--modal-header">
							<h3 className="bx--modal-header__heading">Extract audits</h3>
							<Button className="bx--modal-close" renderIcon={Close16} onClick={this.closeMassiveExtractionModal} />
						</div>

						<div className="bx--modal-content bx-modal-content-detail">
							<div className="bx--row">
								<div className="bx--col-lg-12 bx--col-md-12">
									<h5 className="align-center">
										Choose at least one country and/or business line
									</h5>
									<div className="align-center">
										Download maximum of 5 audits at a time
									</div>
								</div>
							</div>
							<div className="bx--row">
								<div className="bx--col-lg-12 bx--col-md-12">
									<FormGroup legendText="">
										<FormLabel className="some-class">Country</FormLabel>
										{this.state.isLoadingModalMassiveExtraction ? (
											<DropdownSkeleton />
										) : (
											<MultiSelect.Filterable
												id="countries"
												key="countries"
												placeholder={
													this.state.selectedCountriesMassiveExtraction < 1
														? 'Choose one or more countries'
														: this.state.selectedCountriesMassiveExtraction.map((elem) => elem.name).join(', ')
													}
												name="countries"
												alt="Countries"
												onChange={(e) => this.hanldeChangeMassiveExtraction('countries', e)}
												itemToString={(item) => (item ? item.name : '')}
												items={this.state.countriesMassiveExtraction}
												type="default"
												disabled={
													this.state.countriesMassiveExtraction == [] 
													|| this.state.countriesMassiveExtraction.length <= 0
												}										
												label=""
												invalid={this.state.validatorCountriesMassiveExtraction !== null}
												invalidText={this.state.validatorCountriesMassiveExtraction}
											/>
										)}
									</FormGroup>
								</div>
								<div className="bx--col-lg-12 bx--col-md-12">
									<FormGroup legendText="">
										<FormLabel className="some-class">Business Line</FormLabel>
										{this.state.isLoadingModalMassiveExtraction ? (
											<DropdownSkeleton />
										) : (
											<MultiSelect.Filterable
												id="businesslines"
												key={'businesslines'}
												placeholder={
													this.state.selectedBusinessLinesMassiveExtraction < 1
														? 'Choose one or more business lines'
														: this.state.selectedBusinessLinesMassiveExtraction.map((elem) => elem.name).join(', ')
													}
												multiCombo={true}
												name="businesslines"
												alt="businesslines"
												onChange={(e) => this.hanldeChangeMassiveExtraction('businessLines', e)}
												itemToString={(item) => (item ? item.name : '')}
												items={this.state.businessLinesMassiveExtraction}
												disabled={
													this.state.businessLinesMassiveExtraction == [] 
													|| this.state.businessLinesMassiveExtraction.length <= 0
												}										
												label=""
												invalid={this.state.validatorBusinessLinesMassiveExtraction !== null}
												invalidText={this.state.validatorBusinessLinesMassiveExtraction}
											/>
										)}
									</FormGroup>
								</div>
							</div>
							<div className="bx--row">
								<div className="bx--col-lg-12 bx--col-md-12">
								<DataTable
									useZebraStyles="true"
									rows={this.state.isLoadingTableMassiveExtraction ? loadingRows : (this.state.auditsMassiveExtraction || [])}
									headers={headersMassiveExtractionTable}
									render={({ rows, getHeaderProps, getSelectionProps, selectedRows, getBatchActionProps }) => (
										<TableContainer>
												<>
													<TableToolbar>
														<TableBatchActions {...getBatchActionProps()}>
															<Online>
																<TableBatchAction disabled={this.state.isLoadingDownloadMassiveExtraction || selectedRows?.length === 0} renderIcon={Download16} onClick={() => this.downloadMassiveExtraction(selectedRows)}>
																	Download
																</TableBatchAction>
															</Online>
														</TableBatchActions>
													</TableToolbar>
													<Table>													
														<TableHead>
															<TableRow>
																<TableHeader />
																{headersMassiveExtractionTable.map((header) => (
																	<TableHeader {...getHeaderProps({ header })}>{header.header}</TableHeader>
																))}
															</TableRow>
														</TableHead>
														<TableBody>
															{rows == null || rows.length === 0 ? (
																<NoRecordsPlaceholder colSpan={headersMassiveExtractionTable.length + 2} />
															) : (
																rows.map((row) => (
																	<TableRow key={row.id}>
																		<Online>
																			<TableSelectRow {...getSelectionProps({ row })} />																
																		</Online>
																		<Offline>
																			<TableCell key={`empty${row.id}`} className="tableActions align-center" />
																		</Offline>

																		{row.cells.map((cell) => (
																			<TableCell key={cell.id}>{this.getCellValue(cell.info, cell.value, this.state.isLoadingTableMassiveExtraction)}</TableCell>
																		))}
																	</TableRow>
																))
															)}
														</TableBody>
													</Table>
												</>
										</TableContainer>
									)}
								/>
								</div>
								
							</div>
							<div className="bx--row">
								<div className="bx--col-lg-12 bx--col-md-12 footer-pagination footer-pagination-modal">
									<Pagination {...paginationMassiveExtractionTableProps()} />
								</div>
							</div>
						</div>
						<div className="bx--modal-footer">
							<Button className="button--max-width" kind="secondary" disabled={this.state.isLoadingDownloadMassiveExtraction} onClick={this.closeMassiveExtractionModal}>
								Cancel
							</Button>
							<Button className="button--max-width" kind="primary" disabled={this.state.isLoadingTableMassiveExtraction} onClick={() => this.searchAuditsForMassiveExtractionModal()}>
								Search
							</Button>
						</div>
					</div>
				</div>
			)
		);
	};
	//#endregion

	render() {
		//costante da aggiornare in seguito all'aggiunta/rimozione dei filtri in AuditList
		const filter = {
			idDivision: this.props.filters?.idDivision || null,
			month: this.props.filters?.month || null,
			type: this.props.filters?.type !== null ? this.props.filters?.type?.name : null,
			scopes: this.props.filters?.scopes || null,
			reasons: this.props.filters?.reasons || null,
			countriesAuditee: this.props.filters?.countriesAuditee || null,
			projectsAuditee: this.props.filters?.projectsAuditee || null,
			subContractors: this.props.filters?.subContractors || null,
			purchaseOrders: this.props.filters?.purchaseOrders || null, //RITM0646764
			idTarget: this.props.filters?.idTarget || null,
			idStatus: this.props.filters?.idStatus || null,
			idPlanStatus: this.props.filters?.idPlanStatus || null,
			workSites: this.props.filters?.workSites?.length > 0 ? this.props.filters?.workSites : null,
			compiler: this.props.filters?.compiler || null,
			planCompiler: this.props.filters?.planCompiler || null,
			approver: this.props.filters?.approver || null,
			divisionManager: this.props.filters?.divisionManager || null,
			auditCode: this.props.filters?.auditCode || null,
			findingCode: this.props.filters?.findingCode || null,
			projectAuditCode: this.props.filters?.projectAuditCode || null,
			projectFindingCode: this.props.filters?.projectFindingCode || null,
			auditRemote: this.props.filters?.auditRemote || null,
			idSection: this.props.filters?.idSection || null,
			idLeadAuditor: this.props.filters?.idLeadAuditor || null,
			idDivisionLeadAuditor: this.props.filters?.idDivisionLeadAuditor || null,
			idCompanyLeadAuditor: this.props.filters?.idCompanyLeadAuditor || null,
			idProjectLeadAuditor: this.props.filters?.idProjectLeadAuditor || null,
		}

		const headers = [
			{
				key: "auditCode",
				header: "Code",
				isSortable: true,
			},
			{
				key: "projectAuditCode",
				header: "Project Audit Code",
				isSortable: true,
			},
			{
				key: "referenceMonth",
				header: "Month",
			},
			{
				key: "auditType",
				header: "Type",
			},
			{
				key: "division",
				//RITM0945977
				// header: "Division",
				header: "Business Line",
			},
			{
				key: "company",
				header: "Company",
			},
			{
				key: "scopes",
				header: "Scope",
			},
			{
				key: "status",
				header: "Program Status",
			},
			{
				key: "checkList",
				header: "Report Status",
			},
		];

		return (
			<AppContext.Consumer>
				{({ user }) => (
					<>
						<Loading active={this.state.isLoadingFile} withOverlay />
						{this.renderFilters()}
						{this.state.modalMassiveExtractionVisible && (this.renderMassiveExtractionModal())}
						<DataTable
							useZebraStyles="true"
							rows={this.props.audits}
							headers={headers}
							render={({ rows, getHeaderProps, getSelectionProps, getBatchActionProps, selectedRows }) => (
								<TableContainer>
									<TableToolbar>
										<TableBatchActions {...getBatchActionProps()}>
											<Online>
												{CanExecuteAction("Audit", "Planning", user, selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null, "Submit", this.getAudit(selectedRows)) ? (
													<TableBatchAction renderIcon={Send16} onClick={() => this.batchActionClick("Submit", "Submit", "Data Approver", true, false, selectedRows)}>
														Submit Program
													</TableBatchAction>
												) : null}

												{/* RITM0565449 */}
												{CanExecuteAction("Audit", "Planning", user, selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null, "Approve", this.getAudit(selectedRows)) ? (
													<TableBatchAction renderIcon={CheckmarkOutline16} onClick={() => this.batchActionClick("Approve", "Approve", "Division Manager", true, false, selectedRows)}>
														Approve Program
													</TableBatchAction>
												) : null}

												{/* RITM0565449 */}
												{CanExecuteAction("Audit", "Planning", user, selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null, "Consolidate", this.getAudit(selectedRows)) ? (
													<TableBatchAction renderIcon={CheckmarkOutline16} onClick={() => this.batchActionClick("Consolidate", "Consolidate", null, false, false, selectedRows)}>
														Consolidate Program
													</TableBatchAction>
												) : null}

												{/* RITM0565449 */}
												{CanExecuteAction("Audit", "Planning", user, selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null, "RejectConsolidate", this.getAudit(selectedRows)) ? (
													<TableBatchAction renderIcon={Error16} onClick={() => this.batchActionClick("RejectConsolidate", "RejectConsolidate", null, false, true, selectedRows)}>
														Reject Consolidate
													</TableBatchAction>
												) : null}

												{CanExecuteAction("Audit", "Planning", user, selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null, "Reject", this.getAudit(selectedRows)) ? (
													<TableBatchAction renderIcon={Error16} onClick={() => this.batchActionClick("Reject", "Reject", null, false, true, selectedRows)}>
														Reject Program
													</TableBatchAction>
												) : null}

												{CanExecuteAction("Audit", "Planning", user, selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null, "Delete", this.getAudit(selectedRows)) ? (
													<TableBatchAction renderIcon={Delete16} onClick={() => this.batchActionClick("Delete", "Delete", null, false, false, selectedRows)}>
														Delete Program
													</TableBatchAction>
												) : null}
												{selectedRows.length > 0 && this.getStatusId(selectedRows[0].id) === 4 && (
													<>
														{CanExecuteAction(
															"Audit",
															this.getNewCarManagement(selectedRows[0].id) ? "FindingReporting": "Reporting",
															user,
															(selectedRows.length > 0 ? this.getReportStatusId(selectedRows[0].id) : null) || "",
															"Create",
															this.getAuditor(selectedRows) // caso particolare, questa azione la può fare l'auditor indicato nel plan
														) ? (
															<TableBatchAction renderIcon={Task16} onClick={() => this.batchActionClick("newreport", "Assign", null, false, false, selectedRows)}>
																Assign Report
															</TableBatchAction>
														) : null}

														{CanExecuteAction(
															"Audit",
															this.getNewCarManagement(selectedRows[0].id) ? "FindingReporting": "Reporting",
															user,
															selectedRows.length > 0 ? this.getReportStatusId(selectedRows[0].id) : null,
															"Submit",
															this.getAuditReport(selectedRows)
														) && this.canSubmit(selectedRows[0].id) ? (
															<TableBatchAction renderIcon={Send16} onClick={() => this.batchActionClick("submitreport", "Submit", "Data Approver", true, false, selectedRows)}>
																Submit Report
															</TableBatchAction>
														) : null}
														{selectedRows.length > 0 && this.getStatusId(selectedRows[0].id) === 4 && this.isAllRequestCancellationPending(selectedRows) ? (
															<TableBatchAction renderIcon={Delete16} onClick={() => this.deleteActionClick(selectedRows)}>
																Request Audit Cancellation
															</TableBatchAction>
														) : null}
														{selectedRows.length > 0 && IsInRole(user, "Administrator") && this.isAllMyRequestCancellationPending(selectedRows, user) ? (
															<TableBatchAction
																renderIcon={Archive16}
																onClick={() => this.batchActionClick("ConfirmCancellationRequest", "Confirm cancellation of ", null, false, false, selectedRows)}
															>
																Confirm Cancellation Request
															</TableBatchAction>
														) : null}
														{/* {CanExecuteAction(
                            'Audit',
                            'Reporting',
                            user,
                            selectedRows.length > 0
                              ? this.getReportStatusId(selectedRows[0].id)
                              : null,
                            'Delete',
                            this.getAuditReport(selectedRows)
                          ) ? (
                            <TableBatchAction
                              renderIcon={Delete16}
                              onClick={() =>
                                this.batchActionClick(
                                  'deletereport',
                                  'Delete',
                                  null,
                                  false,
                                  false,
                                  selectedRows
                                )
                              }
                            >
                              Delete
                            </TableBatchAction>
                          ) : null} */}

														{CanExecuteAction(
															"Audit",
															this.getNewCarManagement(selectedRows[0].id) ? "FindingReporting": "Reporting",
															user,
															selectedRows.length > 0 ? this.getReportStatusId(selectedRows[0].id) : null,
															"Approve",
															this.getAuditReport(selectedRows)
														) ? (
															<TableBatchAction
																renderIcon={CheckmarkOutline16}
																onClick={() => this.batchActionClick("approvereport", "Approve", null, false, false, selectedRows)}
															>
																Approve Report
															</TableBatchAction>
														) : null}

														{CanExecuteAction(
															"Audit",
															this.getNewCarManagement(selectedRows[0].id) ? "FindingReporting": "Reporting",
															user,
															selectedRows.length > 0 ? this.getReportStatusId(selectedRows[0].id) : null,
															"Consolidate",
															this.getAuditReport(selectedRows)
														) ? (
															<TableBatchAction
																renderIcon={CheckmarkOutline16}
																onClick={() => this.batchActionClick("consolidatereport", "Consolidate", null, false, false, selectedRows)}
															>
																Consolidate Report
															</TableBatchAction>
														) : null}

														{CanExecuteAction(
															"Audit",
															this.getNewCarManagement(selectedRows[0].id) ? "FindingReporting": "Reporting",
															user,
															selectedRows.length > 0 ? this.getReportStatusId(selectedRows[0].id) : null,
															"Reject",
															this.getAuditReport(selectedRows)
														) ? (
															<TableBatchAction renderIcon={Error16} onClick={() => this.batchActionClick("rejectreport", "Reject", null, false, true, selectedRows)}>
																Reject Report
															</TableBatchAction>
														) : null}

														{CanExecuteAction(
															"Audit",
															this.getNewCarManagement(selectedRows[0].id) ? "FindingReporting": "Reporting",
															user,
															selectedRows.length > 0 ? this.getReportStatusId(selectedRows[0].id) : null,
															"RejectConsolidate",
															this.getAuditReport(selectedRows)
														) ? (
															<TableBatchAction renderIcon={Error16} onClick={() => this.batchActionClick("rejectconsolidatereport", "Reject", null, false, true, selectedRows)}>
																Reject Report
															</TableBatchAction>
														) : null}
													</>
												)}
											</Online>
										</TableBatchActions>

										<TableToolbarContent>
											{/* <TableToolbarSearch expanded onChange={onInputChange} /> */}
											<TooltipDefinition
													direction="left"  
													align="center"                     
													tooltipText="Filter"
													>
												<Button onClick={this.showFilters} className="buttonPaddingIcon" renderIcon={Data16} iconDescription="Show Filters">

			
													</Button> 
											</TooltipDefinition>
                                      
											<>
												<Online>
													<TooltipDefinition
													direction="left"  
													align="center"                        
													tooltipText="Massive extraction"
													>
														<Button
															renderIcon={Printer}
															iconDescription="Download Audits List"
															className="buttonPaddingIcon"
															onClick={this.openMassiveExtractionModal}
														/>
													</TooltipDefinition>
												</Online>
											</>
											<>
												<Online>
													<TooltipDefinition
													direction="left"
													align="center"                      
													tooltipText="Download Audits List"
													>
														<FileDownLoadButton
																onError={(error) => {
																	showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.EXPORTAUDITS, apioperation.DOWNLOAD));
																	this.setState({
																		isLoadingFile: true,
																	});
																}}
																renderIcon={Download16}
																iconDescription="Download Audits List"
																className="buttonPaddingIcon"
																apiUrl={`/audit/${this.props.selectedYear === null || this.props.selectedYear === undefined ? new Date().getFullYear() : this.props.selectedYear}/excel`}
																method="post"
																postBody={filter}
																fileName={`${"Export_Audits_"}${moment().format("YYYYMMDDHHmmSS")}.xlsx`}
																onDownLoadStart={() => {
																	this.setState({
																		isLoadingFile: true,
																	});
																}}
																onDownLoadEnd={() => {
																	this.setState({
																		isLoadingFile: false,
																	});
																}}
														>
																{/* Download Audits List */}
														</FileDownLoadButton>
													</TooltipDefinition>
												</Online>
											</>
											<>
												<Online>
													<TooltipDefinition
															direction="left"     
															align="center"                   
														tooltipText="Download Audit Programs"
															>
														<FileDownLoadButton
															onError={(error) => {
																showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.EXPORTAUDITS, apioperation.DOWNLOAD));
																this.setState({
																	isLoadingFile: true,
																});
															}}
															renderIcon={DocumentDownload16}
															iconDescription="Download Audit Programs"
															className="buttonPaddingIcon"
															apiUrl={`/audit/${this.props.selectedYear === null || this.props.selectedYear === undefined ? new Date().getFullYear() : this.props.selectedYear}/exportplans`}
															method="post"
															postBody={filter}
															fileName={`${"Export_Audits_Programme_"}${moment().format("YYYYMMDDHHmmSS")}.zip`}
															onDownLoadStart={() => {
																this.setState({
																	isLoadingFile: true,
																});
															}}
															onDownLoadEnd={() => {
																this.setState({
																	isLoadingFile: false,
																});
															}}
														>
														{/* Download Audit Programs */}
														</FileDownLoadButton>
													</TooltipDefinition>
												</Online>
											</>

											<div className="header-action ">
												{IsInRole(user, "Administrator") || IsInRole(user, "Compiler") ? (
													<Link to="/audit/program">
														<Button renderIcon={Add16} onClick={this.props.onNewAudit}>
															Program new audit
														</Button>
													</Link>
												) : null}
											</div>
										</TableToolbarContent>
									</TableToolbar>
									{this.renderMonthsHeader()}

									<WFActionModal
										show={this.state.isApprovalModalOpen}
										// title={`${this.state.approvalModalAction} Audits`}
										title={this.state.statewf < 4 ? `${this.state.approvalModalAction} Audits` : `${this.state.approvalModalAction} Audits Report`}
										action={this.state.approvalModalAction}
										withApprover={this.state.withApprover}
										approver={this.state.approver}
										approverRole={this.state.approverRole}
										approverOptions={this.state.approvers}
										isLoadingOperation={this.state.isLoadingWFOperation}
										onApproverSelect={this.handleApproverSelect}
										isLoadingOptions={this.state.isLoadingApproverOptions}
										onCancel={this.handleCloseApprovalModal}
										onConfirm={this.handleConfirmApprovalModal}
										onApprovalNotesChange={this.handleApprovalNotesChange}
										approvalNotes={this.state.approvalNotes}
										approvalNotesRequired={this.state.approvalNotesRequired}
										validationMessages={this.state.approvalValidationMessages}
									/>
									<AuditDeleteRequest
										show={this.state.isDeleteRequestModalOpen}
										title="Request Audit Cancellation"
										action={this.state.approvalModalAction}
										withApprover={this.state.withApprover}
										approver={this.state.approver}
										approverRole={this.state.approverRole}
										approverOptions={this.state.approvers}
										isLoadingOperation={this.state.isLoadingWFOperation}
										onApproverSelect={this.handleApproverSelect}
										isLoadingOptions={this.state.isLoadingApproverOptions}
										onCancel={this.handleCloseDeleteRequestModal}
										onConfirm={this.handleConfirmDeleteRequestModal}
										onApprovalNotesChange={this.handleApprovalNotesChange}
										approvalNotes={this.state.approvalNotes}
										approvalNotesRequired={this.state.approvalNotesRequired}
										//RITM0946162
										reasonForAuditCancellationOptions={this.state.reasonForAuditCancellation}
										onReasonForAuditCancellationSelect ={this.handleReasonForAuditCancellationSelect}
										auditCancellationReason={this.state.auditCancellationReason}
										//End
										validationMessages={this.state.approvalValidationMessages}
									/>

									<Table>
										<TableHead>
											<TableRow>
												<Online>
													<TableSelectAll {...getSelectionProps()} />
												</Online>
												<Offline>
													<TableSelectAll {...getSelectionProps()} disabled />
												</Offline>
												{headers.map((header) => (
													<TableHeader {...getHeaderProps({ header })}>{header.header}</TableHeader>
												))}
												<TableHeader className="align-center">Actions</TableHeader>
											</TableRow>
										</TableHead>
										<TableBody>
											{rows == null || rows.length === 0 ? (
												<NoRecordsPlaceholder colSpan={headers.length + 2} />
											) : (
												rows.map((row) => (
													<TableRow key={row.id}>
														<Online>
															{this.IsRowSelectable(row, selectedRows) ? (
																<TableSelectRow {...getSelectionProps({ row })} />
															) : (
																<TableCell key={`empty${row.id}`} className="tableActions align-center" />
															)}
														</Online>
														<Offline>
															<TableSelectRow {...getSelectionProps({ row })} disabled />
														</Offline>

														{row.cells.map((cell) => (
															<TableCell key={cell.id}>{this.getCellValue(cell.info, cell.value)}</TableCell>
														))}
														<TableCell key={`action-${row.id}`} className="tableActions align-center">
															<div>
																<Online>
																	{this.getReportStatusId(row.id) && (
																		<FileDownLoadButton
																			onError={(error) => {
																				showNotification.error(getError(error, entitiesLabels.AUDIT_NOTIFICATION, apioperation.DOWNLOAD));
																			}}
																			size="small"
																			className="bx--export-form"
																			renderIcon={ExportDoc16}
																			iconDescription="Download Notification"
																			title="Download Notification"
																			kind="ghost"
																			apiUrl={`/audit/${row.id}/export`}
																			// fileName={`Audit_Notification_${row.auditCode}.pdf`}
																			fileName={this.getAuditCode(row.id)}
																			onDownLoadStart={() => {
																				this.setState({
																					isLoadingFile: true,
																				});
																			}}
																			onDownLoadEnd={() => {
																				this.setState({
																					isLoadingFile: false,
																				});
																			}}
																		/>
																	)}
																	{this.getReportStatusId(row.id) && (
																		<FileDownLoadButton
																			onError={(error) => {
																				showNotification.error(getError(error, entitiesLabels.AUDIT_REPORT, apioperation.DOWNLOAD));
																			}}
																			size="small"
																			className=" bx--export-tab-form"
																			renderIcon={ExportDoc16}
																			iconDescription="Download Report"
																			title="Download Report"
																			kind="ghost"
																			apiUrl={`/audit/${row.id}/exportreport`}
																			// fileName={`Audit_Report_${row.auditCode}.pdf`}
																			fileName={this.getAuditReportCode(row.id)}
																			onDownLoadStart={() => {
																				this.setState({
																					isLoadingFile: true,
																				});
																			}}
																			onDownLoadEnd={() => {
																				this.setState({
																					isLoadingFile: false,
																				});
																			}}
																		/>
																	)}
																</Online>
																<Offline>
																	{this.getReportStatusId(row.id) && (
																		<FileDownLoadButton
																			size="small"
																			className="bx--export-form"
																			renderIcon={ExportDoc16}
																			iconDescription="Download Notification"
																			title="Download Notification"
																			kind="ghost"
																			apiUrl={`/audit/${row.id}/export`}
																			fileName={`Audit_Notification_${row.auditCode}.zip`}
																			disabled
																		/>
																	)}
																	{this.getReportStatusId(row.id) && (
																		<FileDownLoadButton
																			size="small"
																			className=" bx--export-tab-form"
																			renderIcon={ExportDoc16}
																			iconDescription="Download Report"
																			title="Download Report"
																			kind="ghost"
																			apiUrl={`/audit/${row.id}/exportreport`}
																			fileName={`Audit_Report_${row.auditCode}.zip`}
																			disabled
																		/>
																	)}
																</Offline>
																{(this.getReportStatusId(row.id) == null || IsInRole(user, "Administrator")) && (
																	<Link to={`/audit/program/${row.id}`}>
																		<Button
																			//onClick={() => this.props.onEditAudit(row)}
																			size="small"
																			renderIcon={Edit16}
																			title="Edit Audit Plan"
																			iconDescription="Edit Audit Plan"
																			kind="ghost"
																		/>
																	</Link>
																)}
																{this.getReportStatusId(row.id) && (
																	<Link to={`/audit/${row.id}`}>
																		<Button size="small" renderIcon={Report16} title="Edit Audit Report" iconDescription="Edit Audit Report" kind="ghost" />
																	</Link>
																)}
																<Online>
																	{this.isMyRequestCancellationPending(row.id, user) && IsInRole(user, "Administrator") && (
																		<Button
																			onClick={() => this.batchActionClick("ConfirmCancellationRequest", "Confirm cancellation of ", null, false, false, [].concat(row))}
																			size="small"
																			renderIcon={Delete16}
																			title="Confirm Audit Cancellation"
																			iconDescription="Confirm Audit Cancellation"
																			kind="ghost"
																		/>
																	)}
																	{this.getStatusId(row.id) === 4 && !this.isRequestCancellationPending(row.id) && (
																		<Button
																			onClick={() => this.deleteActionClick([].concat(row))}
																			size="small"
																			renderIcon={Delete16}
																			title="Request Audit Cancellation"
																			iconDescription="Request Audit Cancellation"
																			kind="ghost"
																		/>
																	)}
																</Online>
															</div>
														</TableCell>
													</TableRow>
												))
											)}
										</TableBody>
									</Table>
								</TableContainer>
							)}
						/>
					</>
				)}
			</AppContext.Consumer>
		);
	}
}

AuditMultiSelectDataTable.propTypes = {
	audits: PropTypes.array.isRequired,
	itemsInMonths: PropTypes.array.isRequired,
	totalItems: PropTypes.string.isRequired,
	showFilters: PropTypes.bool.isRequired,
	onShowFilters: PropTypes.func.isRequired,
	onNewAudit: PropTypes.func.isRequired,
	onEditAudit: PropTypes.func.isRequired,
	onItemDelete: PropTypes.func,
	onMonthFilter: PropTypes.func.isRequired,
	onTypeFilter: PropTypes.func.isRequired,
	onScopeFilter: PropTypes.func.isRequired,
	onReasonFilter: PropTypes.func.isRequired,
	onCountryFilter: PropTypes.func.isRequired,
	onProjectAuditeeFilter: PropTypes.func.isRequired,
	onSubContractorFilter: PropTypes.func.isRequired,
	onRefreshData: PropTypes.func.isRequired,
	onTargetFilter: PropTypes.func.isRequired,
	onStatusFilter: PropTypes.func.isRequired,
	onPlanStatusFilter: PropTypes.func.isRequired,
	onAuditRemoteFilter: PropTypes.func.isRequired,
	onWorkSiteFilter: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired,
	onSearch: PropTypes.func.isRequired,
	onSearchClear: PropTypes.func.isRequired,
	selectedAuditType: PropTypes.object,
	selectedScopes: PropTypes.array,
	selectedReasons: PropTypes.array,
	selectedCountries: PropTypes.array,
	selectedProjectsAuditee: PropTypes.array,
	selectedTarget: PropTypes.object,
	selectedStatus: PropTypes.object,
	selectedPlanStatus: PropTypes.object,
	selectedAuditRemote: PropTypes.object,
	selectedWorkSites: PropTypes.array,
	selectedCompiler: PropTypes.string,
	selectedPlanCompiler: PropTypes.string,
	selectedApprover: PropTypes.string,
	selectedDivisionManager: PropTypes.string,
	selectedMonth: PropTypes.string,
	selectedCode: PropTypes.string,
	selectedProjectAuditCode: PropTypes.string,
	selectedFindingCode: PropTypes.string,
	selectedProjectFindingCode: PropTypes.string,
	selectedSubContractors: PropTypes.string, //RITM0964998 - Download Audit Programs Fix
	selectedPurchaseOrder: PropTypes.string, //RITM0964998 - Download Audit Programs Fix
	onCompilerFilter: PropTypes.func.isRequired,
	onPlanCompilerFilter: PropTypes.func.isRequired,
	onPurchaseOrderFilter: PropTypes.func.isRequired,
	onApproverFilter: PropTypes.func.isRequired,
	onDivisionManagerFilter: PropTypes.func.isRequired,
	onCodeFilter: PropTypes.func.isRequired,
};
AuditMultiSelectDataTable.defaultProps = {
	selectedAuditType: null,
	selectedScopes: null,
	selectedReasons: null,
	selectedCountries: null,
	selectedProjectsAuditee: null,
	selectedTarget: null,
	selectedStatus: null,
	selectedPlanStatus: null,
	selectedAuditRemote: null,
	onItemDelete: null,
	selectedWorkSites: null,
	selectedCompiler: null,
	selectedPlanCompiler: null,
	selectedApprover: null,
	selectedDivisionManager: null,
	selectedCode: null,
	selectedProjectAuditCode: null,
	selectedFindingCode: null,
	selectedProjectFindingCode: null,
	selectedMonth: null,
	selectedSubContractors: null, //RITM0964998 - Download Audit Programs Fix
	selectedPurchaseOrder: null, //RITM0964998 - Download Audit Programs Fix
};
